import numeral from 'numeral';

export default {
  round(value) {
    return numeral(value).format("0,0");
  },
  
  decimal(value) {
    return numeral(value).format("0,0.000");
  },

  twoDecimal(value) {
    return numeral(value).format("0,0.00");
  },

  percentage(value) {
    return value.toString() + '%';
  },
};